import React from 'react'

export default function BtnCrossIcon() {
    return (
        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.36387 7.14487C8.69737 7.47837 8.69737 8.03037 8.36387 8.36387C8.19137 8.53637 7.97287 8.61687 7.75437 8.61687C7.53587 8.61687 7.31737 8.53637 7.14487 8.36387L4.49987 5.71887L1.85487 8.36387C1.68237 8.53637 1.46387 8.61687 1.24537 8.61687C1.02687 8.61687 0.808367 8.53637 0.635867 8.36387C0.302367 8.03037 0.302367 7.47837 0.635867 7.14487L3.28087 4.49987L0.635867 1.85487C0.302367 1.52137 0.302367 0.969367 0.635867 0.635867C0.969367 0.302367 1.52137 0.302367 1.85487 0.635867L4.49987 3.28087L7.14487 0.635867C7.47837 0.302367 8.03037 0.302367 8.36387 0.635867C8.69737 0.969367 8.69737 1.52137 8.36387 1.85487L5.71887 4.49987L8.36387 7.14487Z" fill="white" />
        </svg>

    )
}
